import TaskListWrapper from "../TaskListWrapper";

export default function TodoList({ list }) {
  return <TaskListWrapper data={list} />;
}
